// import { useContext, useEffect, useState } from "react";
// import Button from "react-bootstrap/Button";
// import Form from "react-bootstrap/Form";
// import Modal from "react-bootstrap/Modal";
// import "./BusinessGroupListUpdate.css";
// import { AppThemeContext } from "../../../../../../context/AppThemeContext";
// import { BaseUrl } from "../../../../../../api/AxiosApi";
// import { Business } from "@mui/icons-material";

// function BusinessGroupListUpdate({ show, handleClose, userData, handleUpdate }) {
//     const { PrimaryColor } = useContext(AppThemeContext);
//     const [formData, setFormData] = useState({
//         userId: "",
//         userName: "",
//         address: "",
//         email: "",
//         password: "",
       
//     });

//     const User_ID=localStorage.getItem("LOGIN_ID");

//     useEffect(() => {
//         if (userData) {
//             setFormData({
//                 userId: userData.Group_id || "",
//                 userName: userData.CompanyName || "",
//                 address: userData.Address || "",
//                 email: userData.Email || "",
//                 password: userData.Password || "",
               
//             });
//         }
//     }, [userData]);

    
//     const handleChange = (e) => {
//         const { name, value } = e.target;
//         setFormData((prevData) => ({
//             ...prevData,
//             [name]: value,
//         }));
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();

//         if (!formData.userId) {
//             console.error("User ID is missing. Cannot update.");
//             return;
//         }

//         try {
//             const queryParams = new URLSearchParams({
//                 Group_Name: formData.userName,
//                 Address: formData. address,
//                 Mail_ID: formData.email,
//                 Password: formData.password,
//                 SKey: "XYZ"
//             }).toString();

//             const formBody = new URLSearchParams({
//                 USER_ID: User_ID,
//                 Group_ID:formData.userId
//             }).toString();

//             const finalUrl = `${BaseUrl}CMN_10_Update/iGroup?${queryParams}`;
//             console.log("API URL:", finalUrl);

//             const response = await fetch(finalUrl, {
//                 method: "POST",
//                 headers: {
//                     "Content-Type": "application/x-www-form-urlencoded",
//                 },
//                 body: formBody,
//             });

//             console.log("API Response:", response);

//             if (!response.ok) {
//                 throw new Error("Failed to update user");
//             }

//             const rawResponse = await response.text();
//             console.log("Raw API Response:", rawResponse);

//             const result = JSON.parse(rawResponse);
//             console.log("API Response Data:", result);

//             if (result.success) {
//                 handleUpdate(result); // Notify parent component
//                 handleClose(); // Close modal
//             }
//         } catch (error) {
//             console.error("Error updating user:", error);
//         }
//     };
//     return (

//         <>
//           <Modal show={show} onHide={handleClose} centered>
//             <Modal.Header closeButton className="modal-header-custom" style={{ backgroundColor: PrimaryColor }}>
//                 <Modal.Title>Update User Details</Modal.Title>
//             </Modal.Header>
//             <Modal.Body>
//                 <Form onSubmit={handleSubmit}>
//                     <div className="row">
//                         <div className="col-md-12">
//                             <Form.Group className="mb-1">
//                                 <Form.Label>User ID</Form.Label>
//                                 <Form.Control type="text" name="userId" value={formData.userId} readOnly className="readonly-input" />
//                             </Form.Group>
//                         </div>

                       

//                         <div className="col-md-12">
//                             <Form.Group className="mb-1">
//                                 <Form.Label>User Name</Form.Label>
//                                 <Form.Control type="text" name="userName" value={formData.userName} onChange={handleChange} />
//                             </Form.Group>
//                         </div>

                        
//                         <div className="col-md-12">
//                             <Form.Group className="mb-1">
//                                 <Form.Label>Address</Form.Label>
//                                 <Form.Control type="text" name="address" value={formData.address} onChange={handleChange} />
//                             </Form.Group>
//                         </div>
                        

//                         <div className="col-md-12">
//                             <Form.Group className="mb-1">
//                                 <Form.Label>Email</Form.Label>
//                                 <Form.Control type="email" name="email" value={formData.email} onChange={handleChange} />
//                             </Form.Group>
//                         </div>

//                         <div className="col-md-12">
//                             <Form.Group className="mb-1">
//                                 <Form.Label>Password</Form.Label>
//                                 <Form.Control type="text" name="password" value={formData.password} onChange={handleChange} />
//                             </Form.Group>
//                         </div>

                     
//                     </div>

//                     <Modal.Footer>
//                         <Button onClick={handleClose} style={{ backgroundColor: PrimaryColor }}>
//                             Cancel
//                         </Button>
//                         <Button type="submit" style={{ backgroundColor: PrimaryColor }}>
//                             Update
//                         </Button>
//                     </Modal.Footer>
//                 </Form>
//             </Modal.Body>
//         </Modal> 
//         </>
      


//     );
// }

// export default BusinessGroupListUpdate;


import { useContext, useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import "./BusinessGroupListUpdate.css";
import { AppThemeContext } from "../../../../../../context/AppThemeContext";
import { BaseUrl } from "../../../../../../api/AxiosApi";
import { Business } from "@mui/icons-material";

function BusinessGroupListUpdate({ show, handleClose, userData, handleUpdate }) {
    const { PrimaryColor } = useContext(AppThemeContext);
    const [formData, setFormData] = useState({
        userId: "",
        userName: "",
        address: "",
        email: "",
        password: "",
       
    });

    const User_ID=localStorage.getItem("LOGIN_ID");

    useEffect(() => {
        if (userData) {
            setFormData({
                userId: userData.Group_id || "",
                userName: userData.CompanyName || "",
                address: userData.Address || "",
                email: userData.Email || "",
                password: userData.Password || "",
               
            });
        }
    }, [userData]);

    
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.userId) {
            console.error("User ID is missing. Cannot update.");
            return;
        }

        try {
            const queryParams = new URLSearchParams({
                Group_Name: formData.userName,
                Address: formData. address,
                Mail_ID: formData.email,
                Password: formData.password,
                SKey: "XYZ"
            }).toString();

            const formBody = new URLSearchParams({
                USER_ID: User_ID,
                Group_ID:formData.userId,
                TYPE_ID:"U"
            }).toString();

            const finalUrl = `${BaseUrl}CMN_10_Update/iGroup?${queryParams}`;
            console.log("API URL:", finalUrl);

            const response = await fetch(finalUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                },
                body: formBody,
            });

            console.log("API Response:", response);

            if (!response.ok) {
                throw new Error("Failed to update user");
            }

            const rawResponse = await response.text();
            console.log("Raw API Response:", rawResponse);

            const result = JSON.parse(rawResponse);
            console.log("API Response Data:", result);

            if (result.success) {
                handleUpdate(result); // Notify parent component
                handleClose(); // Close modal
            }
        } catch (error) {
            console.error("Error updating user:", error);
        }
    };
    return (

        <>
          <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton className="modal-header-custom" style={{ backgroundColor: PrimaryColor }}>
                <Modal.Title>Update User Details</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={handleSubmit}>
                    <div className="row">
                        <div className="col-md-12">
                            <Form.Group className="mb-1">
                                <Form.Label style={{color:"black"}}>User ID</Form.Label>
                                <Form.Control type="text" name="userId" value={formData.userId} readOnly className="readonly-input" />
                            </Form.Group>
                        </div>

                       

                        <div className="col-md-12">
                            <Form.Group className="mb-1">
                                <Form.Label  style={{color:"black"}}>User Name</Form.Label>
                                <Form.Control type="text" name="userName" value={formData.userName} onChange={handleChange} />
                            </Form.Group>
                        </div>

                        
                        <div className="col-md-12">
                            <Form.Group className="mb-1">
                                <Form.Label  style={{color:"black"}}>Address</Form.Label>
                                <Form.Control type="text" name="address" value={formData.address} onChange={handleChange} />
                            </Form.Group>
                        </div>
                        

                        {/* <div className="col-md-12">
                            <Form.Group className="mb-1">
                                <Form.Label>Email</Form.Label>
                                <Form.Control type="text" name="email" value={formData.email} onChange={handleChange} />
                            </Form.Group>
                        </div> */}

                        <div className="col-md-12">
                            <Form.Group className="mb-1">
                                <Form.Label  style={{color:"black"}}>Email</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    style={{
                                        minHeight: '80px',
                                        width: '100%',
                                        overflow: 'auto',
                                        whiteSpace: 'normal',
                                        wordWrap: 'break-word',
                                        resize: 'vertical',
                                        fontSize: '14px', // optional: improves appearance
                                        padding: '10px'   // optional: for better spacing
                                    }}
                                />
                            </Form.Group>
                        </div>

                        <div className="col-md-12">
                            <Form.Group className="mb-1">
                                <Form.Label  style={{color:"black"}}> Password</Form.Label>
                                <Form.Control type="text" name="password" value={formData.password} onChange={handleChange} />
                            </Form.Group>
                        </div>

                     
                    </div>

                    <Modal.Footer>
                        <Button onClick={handleClose} style={{ backgroundColor: PrimaryColor }}>
                            Cancel
                        </Button>
                        <Button type="submit" style={{ backgroundColor: PrimaryColor }}>
                            Update
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal.Body>
        </Modal> 
        </>
      


    );
}

export default BusinessGroupListUpdate;